import { render, staticRenderFns } from "./ResidentStatusTab.vue?vue&type=template&id=f179835a&scoped=true&lang=pug"
import script from "./ResidentStatusTab.vue?vue&type=script&lang=ts"
export * from "./ResidentStatusTab.vue?vue&type=script&lang=ts"
import style0 from "./ResidentStatusTab.vue?vue&type=style&index=0&id=f179835a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f179835a",
  null
  
)

export default component.exports